import { type ReactElement } from 'react'
import { AuthenticatedLayout } from '../../../shared/components/layouts/AuthenticatedLayout'
import { CustomerDetail } from '../../../routes/app/customers/[id]/CustomerDetail'

export const buildAppCustomerPath = (id: string | number): string => `/app/customers/${id}`

function CustomersPage (): ReactElement {
  return <CustomerDetail />
}

CustomersPage.getLayout = function getLayout (page: ReactElement) {
  return (
    <AuthenticatedLayout>
      {page}
    </AuthenticatedLayout>
  )
}
export default CustomersPage
